import { createFileRoute } from '@tanstack/react-router'
import { RunPage } from '../../../../../features/payroll/run-page'
import { runPageSearchSchema } from '../../../../../features/payroll/search'

export const Route = createFileRoute('/_app/payroll/runs/$runId/')({
  validateSearch: runPageSearchSchema,
  component: RunPage,
})
